module.exports = __webpack_public_path__ + "img/light-mode.fd036f4d.svg";